import { ServiceRequest } from 'fhir/r4';

export type ServiceRequestType = 'laboratory' | 'imaging' | 'procedure' | 'surgery' | 'observation' | 'others';

const toText = (value: unknown): string => (value == null ? '' : String(value)).trim().toLowerCase();

export const inferServiceRequestType = (sr: ServiceRequest | any): ServiceRequestType => {
  const categories: any[] = Array.isArray(sr?.category) ? sr.category : [];
  const codes = categories
    .flatMap((c: any) => (Array.isArray(c?.coding) ? c.coding : []))
    .map((cc: any) => toText(cc?.code))
    .filter(Boolean);
  const displays = categories
    .flatMap((c: any) => [toText(c?.text), ...(Array.isArray(c?.coding) ? c.coding.map((cc: any) => toText(cc?.display)) : [])])
    .filter(Boolean);

  const has = (needle: string) => {
    const n = toText(needle);
    return codes.includes(n) || displays.includes(n);
  };

  if (has('observation') || has('observations') || has('vital') || has('vitals') || has('vital-signs')) return 'observation';
  if (has('laboratory') || has('lab') || has('lab-tests')) return 'laboratory';
  if (has('imaging') || has('rad')) return 'imaging';
  if (has('surgery')) return 'surgery';
  if (has('procedure')) return 'procedure';
  return 'others';
};
